// utils/tenantUtils.js

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const localhostIndex = parts.indexOf('localhost');
  if (localhostIndex > 0) { // Ensure there are enough parts before 'localhost'
    return parts[localhostIndex - 1]; // Return the part immediately before 'localhost'
  }
  return null; // No tenant subdomain
};

// New function for path-based tenant extraction
export const getTenantFromPath = () => {
  const pathname = window.location.pathname;
  
  // Expected format: /$/tenant/rest/of/path
  const parts = pathname.split('/');
  
  // If using prefix like /$/tenant/...
  if (parts[1] === '$' && parts[2]) {
    return parts[2];
  }
  
  return null; // No tenant in path
};

// Save tenant to localStorage for APK/mobile app memory
export const saveTenant = (tenant) => {
  if (tenant) {
    localStorage.setItem('budgit_last_tenant', tenant);
  }
};

// Get saved tenant from localStorage
export const getSavedTenant = () => {
  return localStorage.getItem('budgit_last_tenant');
};

// For backward compatibility, we'll keep getSubdomain but make it check path first
export const getTenant = () => {
  // First try to get from path (new method)
  const pathTenant = getTenantFromPath();
  if (pathTenant) {
    saveTenant(pathTenant); // Save when detected
    return pathTenant;
  }
  
  // Fallback to subdomain (old method)
  const subdomainTenant = getSubdomain();
  if (subdomainTenant) {
    saveTenant(subdomainTenant); // Save when detected
    return subdomainTenant;
  }
  
  // Last fallback: check localStorage (for APK/mobile app)
  const savedTenant = getSavedTenant();
  return savedTenant;
};
